export default "__VITE_ASSET__B9D1gR3Y__"